import styled from '@emotion/styled'
import React from 'react';

type WithChildren<T = {}> = 
T & { children?: React.ReactNode };

const Content = styled.div`
  overflow: auto;
  margin: 1rem;
  padding: 1rem;
  border-radius: 2px 2px 2px 2px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19);
`

export function Panel({ children }: WithChildren){
  return (
        <Content>
            {children}
        </Content>
  );
}
